import { fetcher } from "helpers/fetcher";

import {
  TGetBusinessEstablishmentListReq,
  TGetBusinessEstablishmentListRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBusinessEstablishmentList = async (
  params?: TGetBusinessEstablishmentListReq
) => {
  return await fetcher<
    TGetBusinessEstablishmentListRes,
    TGetBusinessEstablishmentListReq["data"]
  >(ENDPOINT.CORPORATION.GET_BUSINESS_ESTABLISHMENT_LIST, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_BUSINESS_ESTABLISHMENT_LIST.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetBusinessEstablishmentList = async (
  params?: TGetBusinessEstablishmentListReq
) => {
  return (await getBusinessEstablishmentList(params)).data;
};

queryGetBusinessEstablishmentList._key = (
  params?: TGetBusinessEstablishmentListReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_BUSINESS_ESTABLISHMENT_LIST.url, params, key];
